export * as Provisioning from './provisioning';
export * as Users from './users';
export * as Sites from './sites';

export interface Paged<T> {
  lastPage: boolean;
  pageNumber: number;
  totalPages: number;
  totalResults: number;
  pageContent: T[];
}
